import { FiArchive, FiFile, FiFileText, FiGrid, FiImage } from 'react-icons/fi';

const DOCUMENT_ICON_BY_EXTENSION = {
  pdf: FiFileText,
  doc: FiFile,
  docx: FiFile,
  xls: FiGrid,
  xlsx: FiGrid,
  csv: FiGrid,
  txt: FiFileText,
  md: FiFileText,
  png: FiImage,
  jpg: FiImage,
  jpeg: FiImage,
  webp: FiImage,
  zip: FiArchive,
};

const getDocumentIcon = (fileName) => {
  const normalizedName = typeof fileName === 'string' ? fileName.split(/[?#]/)[0] : '';
  const extension = normalizedName.includes('.') ? normalizedName.split('.').pop().toLowerCase() : '';
  return DOCUMENT_ICON_BY_EXTENSION[extension] || FiFile;
};

export { getDocumentIcon };
